import * as angular from 'angular';

angular.module('web-subscription-models-templates', []).run(['$templateCache', ($templateCache) => {

    function requireAll (requireContext) {
        return requireContext.keys().map(val => {
            return {
                tpl: requireContext(val), // tpl will hold the value of your html string
                name: `web-subscription-models/templates/${val.split('/').pop()}` //name is just the filename
            };
        });
    }

    let modules = requireAll(
        import.meta.webpackContext(
            './app',
            { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-commons/dist',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-menus/dist',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );
    modules = modules.concat(
        requireAll(
            import.meta.webpackContext(
                '../node_modules/ib-web-payments/dist',
                { recursive: true, regExp: /^(?:(?!\.component).)*\.html$/ }
            )
        )
    );


    modules.forEach(val => {
        $templateCache.put(val.name, val.tpl);
    });
}]);
